// Whose game the review reads, and which way up the board is. The reader is
// the owner of the game matched against the players; the board shows the
// reader at the bottom, White when the owner played neither side or both.
// Every score shown to the reader is from the reader's side, whatever the
// orientation, so flipping the board never changes a sign.
import { type Color } from '@chess/api-model';

export interface ReviewSides {
  /** The owner's colour, or undefined when the owner matches neither player or both. */
  reader?: Color;
  /** The colour at the bottom of the board. */
  orientation: Color;
}

/** The reader's colour: the player whose name is the owner, compared case-insensitively and ignoring surrounding spaces. The one rule for which side is the reader's. */
export function readerSideOf(record: { owner: string; white: { name: string }; black: { name: string } }): Color | undefined {
  const owner = record.owner.trim().toLowerCase();
  const isWhite = record.white.name.trim().toLowerCase() === owner;
  const isBlack = record.black.name.trim().toLowerCase() === owner;
  if (isWhite === isBlack) return undefined;
  return isWhite ? 'white' : 'black';
}

/** The reader at the bottom; White when there is no reader. */
export function sidesOf(reader: Color | undefined): ReviewSides {
  return { reader, orientation: reader ?? 'white' };
}

/** The colour scores are read for: the reader, or White without one. */
export function referenceOf(sides: ReviewSides | undefined): Color {
  return sides?.reader ?? 'white';
}
